import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import { getMyOrders } from '../utils/api';
import { useAuth } from '../context/AuthContext';

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

// eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!user) return navigate('/login');
    fetchOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchOrders = async () => {
    try {
      const { data } = await getMyOrders();
      setOrders(data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const statusColor = (status) => {
    const colors = { pending: '#f59e0b', confirmed: '#3b82f6', processing: '#8b5cf6', shipped: '#06b6d4', delivered: '#22c55e', cancelled: '#ef4444' };
    return colors[status] || '#aaa';
  };

  return (
    <div style={{ background: '#111', minHeight: '100vh' }}>
      <Navbar />
      <div style={styles.container}>
        <h1 style={styles.title}>My Orders</h1>
        {loading ? (
          <p style={{ color: '#fff', textAlign: 'center' }}>Loading...</p>
        ) : orders.length === 0 ? (
          <div style={styles.empty}>
            <p style={{ color: '#aaa', fontSize: '18px' }}>No orders yet</p>
            <button style={styles.shopBtn} onClick={() => navigate('/products')}>Start Shopping</button>
          </div>
        ) : (
          <div style={styles.list}>
            {orders.map(order => (
              <div key={order._id} style={styles.order}>
                <div style={styles.orderHeader}>
                  <div>
                    <p style={styles.orderId}>Order #{order._id.slice(-8).toUpperCase()}</p>
                    <p style={styles.orderDate}>{new Date(order.createdAt).toLocaleDateString()}</p>
                  </div>
                  <div style={styles.orderRight}>
                    <span style={{ ...styles.status, color: statusColor(order.orderStatus), borderColor: statusColor(order.orderStatus) }}>
                      {order.orderStatus.toUpperCase()}
                    </span>
                    <p style={styles.orderTotal}> {order.totalAmount?.toLocaleString()}</p>
                  </div>
                </div>
                <div style={styles.orderItems}>
                  {order.items.map((item, i) => (
                    <p key={i} style={styles.orderItem}>
                      {item.brand} {item.name} x{item.quantity} — $ {(item.price * item.quantity).toLocaleString()}
                    </p>
                  ))}
                </div>
                <p style={styles.address}>📍 {order.shippingAddress.address}, {order.shippingAddress.city}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  container: { maxWidth: '900px', margin: '0 auto', padding: '40px 20px' },
  title: { color: '#fff', fontSize: '32px', marginBottom: '32px' },
  empty: { textAlign: 'center', padding: '80px 0' },
  shopBtn: { marginTop: '16px', padding: '12px 32px', background: '#e63946', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px' },
  list: { display: 'flex', flexDirection: 'column', gap: '16px' },
  order: { background: '#1a1a1a', borderRadius: '12px', padding: '20px', border: '1px solid #222' },
  orderHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' },
  orderId: { color: '#fff', fontWeight: 'bold', fontSize: '15px' },
  orderDate: { color: '#aaa', fontSize: '13px', marginTop: '4px' },
  orderRight: { textAlign: 'right' },
  status: { fontSize: '12px', fontWeight: 'bold', border: '1px solid', padding: '3px 8px', borderRadius: '4px' },
  orderTotal: { color: '#fff', fontWeight: 'bold', fontSize: '16px', marginTop: '6px' },
  orderItems: { borderTop: '1px solid #222', paddingTop: '12px', marginBottom: '12px' },
  orderItem: { color: '#aaa', fontSize: '13px', marginBottom: '4px' },
  address: { color: '#666', fontSize: '12px' }
};

export default OrdersPage;